import { render, staticRenderFns } from "./adminPanelFormSettings.vue?vue&type=template&id=5899ca2a"
import script from "./adminPanelFormSettings.vue?vue&type=script&lang=js"
export * from "./adminPanelFormSettings.vue?vue&type=script&lang=js"
import style0 from "./adminPanelFormSettings.vue?vue&type=style&index=0&id=5899ca2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports